export const CSS_CLASSES = {
	TITLE: 'widget__title',
	SUBTITLE: 'widget__subtitle',
};
